<template>
  <div id="private-plot-input">
    <vs-button
      class="plot-input-back-button"
      text-color="white"
      type="flat"
      icon-pack="feather"
      icon="icon-arrow-left"
      :to="backTo"
      >戻る</vs-button
    >

    <h4 class="title">
      {{ category_name }}
    </h4>

    <div class="wrapper">
      <vs-row class="mb-2">
        <vs-col vs-w="12">
          <vs-input
            class="w-full required"
            color="success"
            label="タイトル"
            placeholder="プロットタイトル"
            v-validate="'required|max:32'"
            name="title"
            v-model="title"
            data-vv-as="タイトル"
          />
          <div class="text-danger text-sm" v-show="errors.has('title')">
            {{ errors.first("title") }}
          </div>
        </vs-col>
      </vs-row>

      <vs-row v-if="isShowPortOperatorColumn && !isRestriction" class="mb-2">
        <vs-col vs-w="12">
          <vs-input
            class="w-full"
            color="success"
            label="事業者名"
            placeholder="法人名など入力してください"
            v-validate="'max:32'"
            name="installer"
            v-model="installer"
            data-vv-as="事業者名"
          />
          <div class="text-danger text-sm" v-show="errors.has('installer')">
            {{ errors.first("installer") }}
          </div>
        </vs-col>
      </vs-row>

      <vs-row v-if="isShowPortOperatorColumn" class="mb-2">
        <vs-col vs-w="12" class="required">
          <label for="" class="vs-input--label">表示期間</label>
        </vs-col>
        <vs-col class="mb-2" vs-w="12" ref="startDatetime">
          <vue-ctk-date-time-picker
            locale="ja"
            label="開始日時"
            format="YYYY-MM-DDTHH:mm:ss.SSSz"
            formatted="YYYY年MM月DD日 HH:mm"
            minute-interval="10"
            :value="start_datetime | toYMDHMSZ"
            @is-shown="isShownPicker('start')"
            @input="setStartDate"
          />
        </vs-col>
        <vs-col vs-w="12" ref="endDatetime">
          <vue-ctk-date-time-picker
            locale="ja"
            label="終了日時"
            format="YYYY-MM-DDTHH:mm:ss.SSSz"
            formatted="YYYY年MM月DD日 HH:mm"
            minute-interval="10"
            :value="end_datetime | toYMDHMSZ"
            @is-shown="isShownPicker('end')"
            @input="setEndDate"
          />
        </vs-col>
        <div class="text-danger text-sm" v-show="errors.has('datetime_range')">
          {{ errors.first("datetime_range") }}
        </div>
      </vs-row>
      <vs-row v-else-if="isShowRangeDateColumn" class="mt-2">
        <vs-col vs-w="12">
          <label for="" class="vs-input--label">表示期間</label>
        </vs-col>
        <vs-col class="mb-2" vs-w="12">
          <p
            class="label-date"
            v-if="
              this.plot.plot_child_category_id ==
              PLOT_CHILD_CATEGORY.FLOATING_MATTER
            "
          >
            1時間
          </p>
          <p class="label-date" v-else>1日</p>
        </vs-col>
      </vs-row>

      <vs-row v-if="isShowPortOperatorColumn && !isRestriction">
        <vs-col vs-w="12">
          <vs-input
            class="w-full"
            color="success"
            label="電話番号"
            placeholder="電話番号を入力してください"
            name="phone_number"
            v-model="phone_number"
            v-validate="'custom_phoneNumber'"
            data-vv-as="電話番号"
          />
          <div class="text-danger text-sm" v-show="errors.has('phone_number')">
            {{ errors.first("phone_number") }}
          </div>
        </vs-col>
      </vs-row>

      <vs-row class="mt-2 mb-2">
        <vs-col vs-w="12" class="required">
          <label for="" class="vs-input--label">コメント</label><br />
          <vs-textarea
            class="textarea-comment"
            color="success"
            placeholder="プロットの概要を入力してください。"
            v-validate="'required|max:255'"
            name="comment"
            v-model="comment"
            data-vv-as="コメント"
          />
          <div class="text-danger text-sm" v-show="errors.has('comment')">
            {{ errors.first("comment") }}
          </div>
        </vs-col>
      </vs-row>

      <vs-divider class="mt-0 mb-2" color="#ffffff">位置情報</vs-divider>
      <vs-row class="mb-2">
        <vs-col vs-w="8">
          <v-select
            class="w-full v-select-point-input-format-options"
            label="text"
            placeholder="入力単位を選択してください"
            :options="pointInputFormatOptions"
            :clearable="false"
            v-model="selectedFormat"
          >
          </v-select>
          <v-select
            class="w-full mt-2"
            :class="[isRectangularCoordinate ? enableClass : disableClass]"
            label="text"
            placeholder="座標系を選択してください"
            v-model="selectedSystemNumber"
            :options="rectangularCoordinateOptions"
            :clearable="false"
            :disabled="!isRectangularCoordinate"
          >
          </v-select>
        </vs-col>
        <vs-col vs-w="4" vs-type="flex" vs-justify="center" vs-align="center">
          <vs-button
            class="button-clear"
            color="#999999"
            size="small"
            type="filled"
            @click="onClearPoints"
            >クリア
          </vs-button>
        </vs-col>
      </vs-row>

      <vs-row class="mb-2">
        <vs-col vs-w="12">
          <vs-textarea
            class="textarea-points"
            color="success"
            :placeholder="textareaPlaceholder"
            @input="input"
            name="pointsText"
            v-model="pointsText"
          />
          <div class="text-danger text-sm" v-show="errors.has('pointsText')">
            {{ errors.first("pointsText") }}
          </div>
        </vs-col>
      </vs-row>

      <vs-divider class="mt-2 mb-2" color="#ffffff">画像</vs-divider>

      <vs-row>
        <vs-col style="height: 100%" vs-w="12">
          <div v-if="pictures.length > 0">
            <swiper
              :options="swiperOptionTop"
              class="gallery-top"
              ref="swiperTop"
            >
              <swiper-slide :key="item.id" v-for="item in pictures">
                <firebase-storage-picture
                  class="plot-image responsive"
                  :picture="item"
                />
              </swiper-slide>
              <div class="swiper-pagination" slot="pagination"></div>
              <div
                v-if="pictures.length > 1"
                class="swiper-button-prev swiper-button-white"
                slot="button-prev"
              ></div>
              <div
                v-if="pictures.length > 1"
                class="swiper-button-next swiper-button-white"
                slot="button-next"
              ></div>
            </swiper>
            <swiper
              :options="swiperOptionThumbs"
              ref="swiperThumbs"
              class="gallery-thumbs"
            >
              <swiper-slide :key="item.id" v-for="item in pictures">
                <firebase-storage-picture
                  class="plot-image responsive"
                  :picture="item"
                />
              </swiper-slide>
            </swiper>
          </div>
          <div align="center">
            <vs-button
              icon-pack="feather"
              icon="icon-image"
              class="mt-2"
              color="success"
              type="filled"
              vs-w="12"
              @click="showDialogUpload"
              >画像登録</vs-button
            >
          </div>
          <dialog-upload-plot-image
            ref="dialogUploadPlotImage"
            @pictureUploaded="pictureUploaded"
          />
        </vs-col>
      </vs-row>

      <vs-divider class="mb-4" color="#ffffff" />

      <vs-row v-if="plotRegistrant" class="plot-registrant mb-4 pl-3">
        <vs-col vs-w="3"> 登録者 </vs-col>
        <vs-col vs-w="9">
          {{ plotRegistrant }}
        </vs-col>
      </vs-row>

      <vs-row v-if="this.plot && this.plot.hash" class="mb-12 action-buttons">
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
          <vs-button color="danger" type="filled" @click="onDeleteConfirm"
            >削除</vs-button
          >
        </vs-col>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
          <vs-button color="primary" type="filled" @click="onSaveConfirm"
            >保存</vs-button
          >
        </vs-col>
      </vs-row>

      <vs-row v-else class="action-buttons">
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
          <vs-button color="primary" type="filled" @click="onSaveConfirm"
            >登録</vs-button
          >
        </vs-col>
      </vs-row>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { createNamespacedHelpers } from "vuex";
import { mapGetters, mapState } from "vuex";
import "swiper/dist/css/swiper.min.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import FirebaseStoragePicture from "@/components/images/FirebaseStoragePicture";
import authService from "@/services/authService";
import PlotMixin from "@/mixins/PlotMixin";
import vSelect from "vue-select";
import "vue-select/src/scss/vue-select.scss";

import { PLOT_CHILD_CATEGORY, PLOT_POINT_INPUT_FORMAT } from "@/config/const";
import * as CollisionLogicUtil from "@/utils/CollisionLogicUtil";
import * as GeoUtil from "@/utils/GeoUtil";
import DialogUploadPlotImage from "@/components/dialogs/DialogUploadPlotImage";
import FireStoreService from "@/services/fireStoreService";
import * as turf from "@turf/turf";
import TileBelt from "@mapbox/tilebelt";

const { mapActions: mapActionsOfPrivatePlot } =
  createNamespacedHelpers("gkmgPrivatePlot");

export default {
  components: {
    swiper,
    swiperSlide,
    DialogUploadPlotImage,
    FirebaseStoragePicture,
    vSelect,
  },
  mixins: [PlotMixin],
  data() {
    return {
      category_name: null,

      // カラム表示判定
      // 港湾業者向け項目表示判定
      isShowPortOperatorColumn: false,
      // 表示期限固定表示項目
      isShowRangeDateColumn: false,
      // 航行制限区域判定
      isRestriction: false,

      // Form
      title: null,
      comment: null,
      installer: null,
      phone_number: null,
      start_datetime: null,
      end_datetime: null,
      pointsText: null,
      pictures: [],

      // Format
      format: PLOT_POINT_INPUT_FORMAT.BASE_10,
      selectedFormat: null,
      selectedSystemNumber: null,

      // Swaper
      swiperOptionTop: {
        spaceBetween: 10,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      swiperOptionThumbs: {
        spaceBetween: 10,
        centeredSlides: true,
        slidesPerView: "auto",
        touchRatio: 0.2,
        slideToClickedSlide: true,
      },

      pointInputFormatOptions: [],
      rectangularCoordinateOptions: [],
      enableClass: "v-select-rectangular-coordinate-input-options-enable",
      disableClass: "v-select-rectangular-coordinate-input-options-disable",
      enterprise_public: null,
    };
  },
  props: {
    map: {
      type: Object,
    },
    plot: {
      type: Object,
    },
  },
  mounted() {
    // 登録と更新でオブジェクトの構造が変わるため
    const child_category_id = this.plot.plot_child_category_id;
    this.category_name =
      PLOT_CHILD_CATEGORY.properties[Number(child_category_id)].label;

    this.isShowPortOperatorColumn = [
      PLOT_CHILD_CATEGORY.CONSTRUCTION,
      PLOT_CHILD_CATEGORY.RESTRICTION,
    ].includes(Number(child_category_id));

    this.isShowRangeDateColumn = [
      PLOT_CHILD_CATEGORY.RESCUE,
      PLOT_CHILD_CATEGORY.ACCIDENT,
      PLOT_CHILD_CATEGORY.FLOATING_MATTER,
    ].includes(Number(child_category_id));

    this.isRestriction = [PLOT_CHILD_CATEGORY.RESTRICTION].includes(
      Number(child_category_id),
    );

    if (this.plot.hash) {
      this.title = this.plot.title;
      this.comment = this.plot.comment;
      this.installer = this.plot.installer;
      this.phone_number = this.plot.phone_number;
      this.start_datetime = this.plot.start_date
        ? moment(this.plot.start_date.seconds * 1000).format("YYYY/MM/DD HH:mm")
        : null;
      this.end_datetime = this.plot.end_date
        ? moment(this.plot.end_date.seconds * 1000).format("YYYY/MM/DD HH:mm")
        : null;
      this.created_at = this.plot.created_at
        ? moment(this.plot.created_at.seconds * 1000).format("YYYY/MM/DD HH:mm")
        : null;
      this.pictures = this.plot.picture || [];

      let points = this.plot.points.map((v) => [v.longitude, v.latitude]);
      this.setPoint(points);
      this.pointsText = this.getTextFromPlotPoints();
    }

    if (this.pictures.length > 0) {
      this.updateSwiper();
    }

    this.$nextTick(() => {
      this.isShownPicker("start");
      this.isShownPicker("end");
    });
  },
  computed: {
    ...mapGetters({
      plotPoints: "gkmgPrivatePlot/getPoints",
      editMode: "gkmgPrivatePlot/getEditMode",
      mapCenter: "enterpriseMapSetting/getCenter",
    }),
    ...mapState({
      PLOT_CHILD_CATEGORY: () => PLOT_CHILD_CATEGORY,
      PLOT_POINT_INPUT_FORMAT: () => PLOT_POINT_INPUT_FORMAT,
    }),
    plotRegistrant() {
      if (this.plot && this.plot.enterprise_public) {
        return `${this.plot.enterprise_public.data.name} (法人)`;
      } else {
        return null;
      }
    },
    backTo() {
      if (this.$route.params.fromLiveMap) {
        return {
          name: "enterprise-live-map",
          params: { plot_hash: this.plot ? this.plot.hash : null },
        };
      } else {
        return {
          name: "enterprise-private-plot-list",
        };
      }
    },
    isRectangularCoordinate() {
      return this.selectedFormat.value === PLOT_POINT_INPUT_FORMAT.XY;
    },
    textareaPlaceholder() {
      return this.selectedFormat.placeholder;
    },
    quadkey() {
      // プライベートプロットのzoom値は23固定
      const zoom = 23;
      // 直接編集するとString型になるため、明示的にキャストする
      // plotPointsは[経度、緯度]で持っている
      const points = this.plotPoints.map((v) => {
        return { longitude: Number(v[0]), latitude: Number(v[1]) };
      });
      // 中心座標を取得
      const collections = points.map((e) => {
        return turf.point([e.longitude, e.latitude]);
      });
      const features = turf.featureCollection(collections);
      // geoJSONは[経度、緯度]で持っている
      const centerGeo = turf.center(features);
      // 経度
      const centerLongitude = Number(centerGeo.geometry.coordinates[0]);
      // 緯度
      const centerLatitude = Number(centerGeo.geometry.coordinates[1]);
      let tile = TileBelt.pointToTile(centerLongitude, centerLatitude, zoom);
      return TileBelt.tileToQuadkey(tile);
    },
  },
  destroyed() {
    this.clear();
  },
  watch: {
    plotPoints() {
      this.validateForPoints();
      if (this.editMode != 2) {
        this.pointsText = this.getTextFromPlotPoints();
      }
    },
    selectedFormat() {
      this.pointsText = this.getTextFromPlotPoints();
    },
    selectedSystemNumber() {
      this.pointsText = this.getTextFromPlotPoints();
    },
    start_datetime() {
      this.validateForDatetimeRange(false);
    },
    end_datetime() {
      this.validateForDatetimeRange(false);
    },
  },
  methods: {
    ...mapActionsOfPrivatePlot(["setPoint", "clear", "setEditMode"]),
    showDialogUpload() {
      this.$refs.dialogUploadPlotImage.show();
    },
    input() {
      try {
        this.$validator.errors.remove("pointsText");

        this.setEditMode(2);
        // this.errors = [];
        const points = [];
        const pointTextList = this.pointsText.split("\n");
        pointTextList.forEach((pointText) => {
          const point = pointText.split(",");
          let lat = point[0];
          let lon = point[1];

          if (!this.isValidPoint(point)) return;
          switch (this.selectedFormat.value) {
            case PLOT_POINT_INPUT_FORMAT.BASE_10:
              points.push([lon, lat]);
              break;
            case PLOT_POINT_INPUT_FORMAT.BASE_60:
              points.push([
                GeoUtil.base60ToBase10(lon),
                GeoUtil.base60ToBase10(lat),
              ]);
              break;
            case PLOT_POINT_INPUT_FORMAT.XY:
              points.push(
                GeoUtil.xyToBase10(
                  Number(lat),
                  Number(lon),
                  this.getRectangularCoordinate(
                    this.selectedSystemNumber.value,
                  ),
                ),
              );
              break;
            default:
              break;
          }
        });

        this.setPoint(points);
        if (points.length && points[0]) {
          this.map.flyTo({ center: [points[0][0], points[0][1]] });
          // this.map.flyTo({ center: [ 139.85535684519846, 35.60761645841015]})
        }
      } catch (e) {
        this.$validator.errors.add({
          field: "pointsText",
          msg: e.message,
        });
      }
    },
    isValidPoint(point) {
      let lon = point[1];
      let lat = point[0];

      if (!lat || !lon) {
        return;
      }
      if (!point.length || !lat || !lon) return false;
      if (isNaN(lat) || isNaN(lon))
        throw new Error("ポイントを正しく入力してください\n" + point);
      if (this.selectedFormat === PLOT_POINT_INPUT_FORMAT.BASE_10) {
        if (lat < -90 || lat > 90)
          throw new Error("緯度は-90〜90を指定してください");
        if (lon < -180 || lon > 180)
          throw new Error("経度は-180〜180を指定してください");
      }
      return true;
    },
    checkPointFormat() {
      this.isFormat = false;
      if (!this.pointsText.length) {
        throw new Error("ポイントを最低一つ設定してください");
      }
      const pointTextList = this.pointsText.split("\n");
      pointTextList.forEach((pointText) => {
        const point = pointText.split(",");
        if (!point.length || !point[0] || !point[1]) {
          this.isFormat = true;
        }
      });
    },
    validateForPoints() {
      this.$validator.errors.remove("pointsText");

      if (this.plotPoints.length == 0) {
        this.$validator.errors.add({
          field: "pointsText",
          msg: "ポイントを最低一つ設定してください",
        });
        return false;
      }

      if (this.plotPoints.length == 2) {
        this.$validator.errors.add({
          field: "pointsText",
          msg: "ポイントは1つまたは3つ以上を設定してください。",
        });
        return false;
      }

      if (CollisionLogicUtil.isLineCrossing(this.plotPoints)) {
        this.$validator.errors.add({
          field: "pointsText",
          msg: "境界線が交差しています",
        });
        return false;
      }
      return true;
    },
    validateForDatetimeRange(strictFlg) {
      this.$validator.errors.remove("datetime_range");
      // 港湾業者向け項目判定
      if (this.isShowPortOperatorColumn) {
        if (!this.start_datetime || !this.end_datetime) {
          if (strictFlg) {
            this.$validator.errors.add({
              field: "datetime_range",
              msg: "表示期間を設定してください。",
            });
            return false;
          }
        } else if (
          moment(this.start_datetime).valueOf() >=
          moment(this.end_datetime).valueOf()
        ) {
          this.$validator.errors.add({
            field: "datetime_range",
            msg: "終了日時は開始日時よりも未来に設定してください。",
          });
          return false;
        }
      }
      return true;
    },
    getTextFromPlotPoints() {
      let text = "";
      this.plotPoints.forEach((point, idx) => {
        let lon = point[0];
        let lat = point[1];

        if (!lat || !lon) {
          return;
        }
        if (idx !== 0) {
          text += "\n";
        }
        switch (this.selectedFormat.value) {
          case PLOT_POINT_INPUT_FORMAT.BASE_10:
            text += lat + "," + lon;
            break;
          case PLOT_POINT_INPUT_FORMAT.BASE_60:
            text +=
              GeoUtil.base10ToBase60(lat) + "," + GeoUtil.base10ToBase60(lon);
            break;
          case PLOT_POINT_INPUT_FORMAT.XY:
            text += GeoUtil.base10ToXY(
              Number(lat),
              Number(lon),
              this.getRectangularCoordinate(this.selectedSystemNumber.value),
            );
            break;
          default:
            break;
        }
      });

      return text;
    },
    onClearPoints() {
      this.setEditMode(1);
      this.clear();
    },
    onDeleteConfirm() {
      authService.getUser().then((v) => {
        this.$vs.dialog({
          type: "confirm",
          color: "danger",
          title: `確認`,
          text:
            v.id == this.plot.enterprise_id
              ? "プロットを削除しますか。"
              : "他のユーザーが登録したプロットです。プロットを削除しますか。",
          accept: this.onDelete,
          acceptText: "削除",
          cancelText: "キャンセル",
        });
      });
    },
    onSaveConfirm() {
      this.$validator.validateAll().then((result) => {
        const isValidForPoints = this.validateForPoints();
        const isValidForDatetimeRange = this.validateForDatetimeRange(true);
        let isValid = isValidForPoints && isValidForDatetimeRange;

        if (result && isValid) {
          authService.getUser().then((v) => {
            this.$vs.dialog({
              type: "confirm",
              color: "primary",
              title: `確認`,
              text:
                this.plot.enterprise_id == null ||
                v.id == this.plot.enterprise_id
                  ? "プロットを保存しますか。"
                  : "他のユーザーが登録したプロットです。プロットを保存しますか。",
              accept: this.onSave,
              acceptText: "保存",
              cancelText: "キャンセル",
            });
          });
        }
      });
    },
    saveHandling(res) {
      if (res.status) {
        let plot = res.data;
        this.$vs.notify({
          title: "プロット「" + plot.title + "」を保存しました。",
          color: "success",
          iconPack: "feather",
          icon: "icon-check",
          position: "bottom-right",
        });
        this.$router.push({
          name: "enterprise-live-map",
          params: { plot_hash: plot.hash },
        });
      } else {
        res.data.forEach((msg) => {
          this.$vs.notify({
            title: "入力エラー",
            text: msg.message,
            color: "danger",
            position: "bottom-right",
          });
        });
      }
    },
    onSave() {
      this.$vs.loading();
      // 直接編集するとString型になるため、明示的にキャストする
      const points = this.plotPoints.map((v) => {
        return { latitude: Number(v[1]), longitude: Number(v[0]) };
      });
      // 中心座標を取得
      const collections = points.map((e) => {
        return turf.point([e.longitude, e.latitude]);
      });
      const features = turf.featureCollection(collections);
      const centerGeo = turf.center(features);
      const center = [
        Number(centerGeo.geometry.coordinates[0]),
        Number(centerGeo.geometry.coordinates[1]),
      ];
      const now = new Date();
      let params = {
        title: this.title,
        detail: {
          comment: this.comment,
          end_date: this.end_datetime ? new Date(this.end_datetime) : null,
          installer: this.installer || null,
          start_date: this.start_datetime
            ? new Date(this.start_datetime)
            : null,
        },
        child_category: {
          id: this.plot.plot_child_category_id,
        },
        points: points,
        center_point: center,
        picture:
          this.pictures && this.pictures.length > 0
            ? this.pictures.map((picture) => {
                return {
                  original_path: picture.original_path,
                  thumbnail_path: picture.thumbnail_path,
                };
              })
            : [],
        deleted_at: null,
        created_at: this.created_at // this.created_atは画面表示ようなので、this.plot.created_atを使用
          ? this.plot.created_at
          : null,
        updated_at: now,
        quadkey: this.quadkey || null,
      };
      if (this.phone_number && this.phone_number.length > 0) {
        params.detail.phone_number = this.phone_number;
      }

      // 浮遊物の場合
      if (
        this.plot.plot_child_category_id == PLOT_CHILD_CATEGORY.FLOATING_MATTER
      ) {
        params.detail.start_date = now;
        params.detail.end_date = moment(now).add(1, "hours").toDate();
      }
      // 救助中,事故の場合
      if (
        this.plot.plot_child_category_id == PLOT_CHILD_CATEGORY.RESCUE ||
        this.plot.plot_child_category_id == PLOT_CHILD_CATEGORY.ACCIDENT
      ) {
        params.detail.start_date = now;
        params.detail.end_date = moment(now).add(1, "days").toDate();
      }

      if (this.plot) {
        this.category_name =
          PLOT_CHILD_CATEGORY.properties[
            this.plot.plot_child_category_id
          ].label;
      }

      // firestore更新
      if (this.plot.hash) {
        params.hash = this.plot.hash;
        FireStoreService.setPrivatePlot(params)
          .then((res) => {
            // 保存処理
            this.saveHandling(res);
          })
          .finally(() => {
            this.$vs.loading.close();
          });
      } else {
        params.created_at = now;
        FireStoreService.setPrivatePlot(params)
          .then((res) => {
            // 保存処理
            this.saveHandling(res);
          })
          .finally(() => {
            this.$vs.loading.close();
          });
      }
    },
    onDelete() {
      this.$vs.loading();

      const params = {
        hash: this.plot.hash,
      };

      FireStoreService.deletePrivatePlot(params)
        .then(() => {
          this.$router.push({
            name: "enterprise-private-plot-list",
          });

          this.$vs.notify({
            title: "プロット「" + this.plot.title + "」を削除しました。",
            color: "danger",
            iconPack: "feather",
            icon: "icon-check",
            position: "bottom-right",
          });
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
    pictureUploaded(picture) {
      this.pictures = [picture].concat(this.pictures);
      this.updateSwiper();
    },
    updateSwiper() {
      this.$nextTick(() => {
        const swiperTop = this.$refs.swiperTop.swiper;
        const swiperThumbs = this.$refs.swiperThumbs.swiper;
        swiperTop.controller.control = swiperThumbs;
        swiperThumbs.controller.control = swiperTop;
      });
    },
    setStartDate(date) {
      this.start_datetime = date;
    },
    setEndDate(date) {
      this.end_datetime = date;
    },
    isShownPicker(type) {
      const startEl = this.$refs.startDatetime
        ? this.$refs.startDatetime.$el
        : null;
      const endEl = this.$refs.endDatetime ? this.$refs.endDatetime.$el : null;
      let datetimeEl =
        type === "start" ? startEl : type === "end" ? endEl : null;
      if (datetimeEl) {
        const popupEl = datetimeEl.querySelector("div.datepicker");
        if (popupEl) {
          const inputBoxEl = datetimeEl.querySelector("div.date-time-picker");
          const pupupHeight =
            popupEl.getBoundingClientRect().height > 0
              ? popupEl.getBoundingClientRect().height
              : 406;
          const xOffset = inputBoxEl
            ? inputBoxEl.getBoundingClientRect().width
            : 324;
          const yOffset = Math.min(
            document.documentElement.clientHeight -
              inputBoxEl.getBoundingClientRect().bottom -
              pupupHeight,
            -1 * inputBoxEl.getBoundingClientRect().height,
          );
          popupEl.style.transform = `translate(${xOffset + 2}px, ${yOffset}px)`;
        }
      }
    },
  },
  created() {
    this.pointInputFormatOptions = this.getPointInputFormatOptions();
    this.rectangularCoordinateOptions = this.getRectangularCoordinateOptions();
    this.selectedFormat = this.pointInputFormatOptions[0]; // 十進法度単位をデフォルト値
    this.selectedSystemNumber = this.rectangularCoordinateOptions[8]; // 9系をデフォルト値
  },
};
</script>

<style lang="sass">
#private-plot-input
  overflow: hidden
  background: rgba(30, 30, 30, .7)

  .v-select-point-input-format-options
    background: white
    border-radius: 5px

  .v-select-rectangular-coordinate-input-options-enable
    background: white
    border-radius: 5px

    .vs__selected
      color: #626262 !important

    .vs__actions
      color: #626262 !important


  .v-select-rectangular-coordinate-input-options-disable
    background: white
    border-radius: 5px

    .vs__selected
      color: #e3e3e3 !important

    .vs__actions
      color: #e3e3e3 !important

  .plot-input-back-button
    padding-left: 1rem !important
    background: rgba(0, 0, 0, 0) !important

  .swiper-button-prev, .swiper-button-next
    filter: drop-shadow(0px 2px 3px black)
    height: 2rem
    top: 55%

  .title
    color: white
    padding: 1rem
    font-weight: bold
    font-size: 1.2rem

  .required>label
    &:after
      content: " *"
      vertical-align: middle
      font-size: 1.5rem
      color: rgba(var(--vs-danger),1)

  .wrapper
    padding: 0rem 1rem 2rem
    height: 100%
    font-size: 0.8rem
    overflow: scroll
    box-sizing: border-box
    width: 350px

    .plot-registrant
      color: white
      font-size: 1rem

    .label-date
      padding: 0.5rem 1rem
      font-size: 1.2rem
      color: white

    .swiper-container
      background-color: #000

    .gallery-top
      height: 12rem !important
      width: 100%

    .gallery-thumbs
      height: 20% !important
      box-sizing: border-box
      padding: 10px 0

    .gallery-thumbs .swiper-slide
      width: 25%
      height: 100%
      opacity: 0.4

    .gallery-thumbs .swiper-slide-active
      opacity: 1

    .plot-image
      height: 100%
      margin: auto

    .datetimepicker
      position: fixed
      top: auto !important

    .vs-input--label
      color: white

      &::placeholder
        font-size: 0.8rem

    .vs-select--item
      line-height: 2.5rem

    .vs-select--input
      font-size: 0.8rem

    .vs-textarea
      background-color: white

      &::placeholder
        font-size: 0.8rem

    .action-buttons
      margin-top: 2rem
      margin-bottom: 8rem
      .vs-button
        width: 90%

    .button-clear
      height: 100%
      width: 100%
      margin-left: 0.5rem
      padding: 0

    .textarea-comment
      margin: 0

      textarea
        height: 6rem
        padding: 0.5rem 1rem
        font-size: 0.8rem
        line-height: 1.3rem

    .textarea-points
      margin: 0

      textarea
        height: 10rem
        padding: 0.5rem 1rem
        font-size: 0.8rem
        line-height: 1.3rem
</style>
